import { Flex } from 'components/base/layout-components';
import { getPageConfig } from '../TeamsConfig.service';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FormItems from '../components/FormItems/FormItems';
import useTeamsConfigProps from '../useTeamsConfigProps';

const AddTeam = ({ type = 'team', team = {} }) => {
  const {
    errors,
    teamProps,
    setTeamProps,
    isSaveEnabled,
    setIsSaveEnabled,
    members,
    setMembers,
    parentGroup,
    setParentGroup,
    nestedTeams,
    setNestedTeams,
    isWithHistory,
    setIsWithHistory,
    withoutBackfill,
    setWithoutBackfill,
    maxMembers,
    newUserManagementEnabled
  } = useTeamsConfigProps({
    type,
    team
  });

  const { pageTitle, isEdit } = getPageConfig({
    type,
    team
  });

  return (
    <Flex direction='column'>
      <Header title={pageTitle} />
      <FormItems
        type={type}
        team={team}
        teamProps={teamProps}
        setTeamProps={setTeamProps}
        parentGroup={parentGroup}
        setParentGroup={setParentGroup}
        nestedTeams={nestedTeams}
        setNestedTeams={setNestedTeams}
        members={members}
        setMembers={setMembers}
        isWithHistory={isWithHistory}
        setIsWithHistory={setIsWithHistory}
        withoutBackfill={withoutBackfill}
        setWithoutBackfill={setWithoutBackfill}
        errors={errors}
        maxMembers={maxMembers}
        newUserManagementEnabled={newUserManagementEnabled}
      />
      <Footer
        type={type}
        isEdit={isEdit}
        isSaveEnabled={isSaveEnabled}
        setIsSaveEnabled={setIsSaveEnabled}
        parentGroup={parentGroup}
        nestedTeams={nestedTeams}
        initialTeamProps={team}
        teamProps={teamProps}
        members={members}
        isWithHistory={isWithHistory}
        withoutBackfill={withoutBackfill}
        maxMembers={maxMembers}
      />
    </Flex>
  );
};

export default AddTeam;
